import styled from "styled-components";

import { colorsPalettes, setFont } from "@similarweb/styles";

import WithTranslation from "../../WithTranslation/src/WithTranslation";

export const StyledHeaderCell = styled.div`
    background-color: ${colorsPalettes.carbon[25]};
    height: 32px;
    color: ${colorsPalettes.carbon[400]};
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    box-sizing: border-box;
    line-height: 32px;
    ${setFont({ $size: 12 })};
`;

export const DefaultHeaderCell = ({ displayName }: { displayName: string }) => {
    return (
        <WithTranslation>
            {(translate) => <StyledHeaderCell>{translate(displayName)}</StyledHeaderCell>}
        </WithTranslation>
    );
};
